module.exports = __webpack_public_path__ + "img/procreate-desktop_jp.5875198.jpg";